<template>
<div class="page page_baocuo page_feedback">
    <!-- 反馈类型 -->
    <div class="baocuo_type">
        <div class="title">反馈问题类型</div>
        <div class="list">
            <div :class="type == 0 ? 'item active' : 'item'" @click="selectType(0)">功能异常</div>
            <div :class="type == 1 ? 'item active' : 'item'" @click="selectType(1)">优化建议</div>
            <div :class="type == 2 ? 'item active' : 'item'" @click="selectType(2)">其他反馈</div>
        </div>
    </div>
    <!--  -->
    <div class="filed">
        <!-- 意见反馈文字 -->
        <div class="filed_nr">
            <van-field v-model="comment" type="textarea" placeholder="请您输入...." maxlength="500" @input="inputFun" />
        </div>
        <!-- 意见反馈图片 -->
        <div class="filed_nr">
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <img class="image" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
        <!-- 字数统计 -->
        <div class="count_num">{{num +'/500'}}</div>
    </div>
    <div class="big_btn bottom">提交</div>
    <!-- <div class="actions">
        <div class="bottom_action" @click="tijiaoFun">提交</div>
    </div> -->
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";

import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            type: null, // 类型
            num: 0, // 字数限制
            comment: '', // 反馈内容
            imglist: [], // 上传回显图片列表
            url: 'http://timemap2.shanmuzhi.com'
        };
    },
    created: function () {

    },
    methods: {
        // 提交
        tijiaoFun() {
            // if (!this.comment) {
            //     this.$toast('反馈内容不能为空');
            //     return
            // }
            // var params = {
            //     token: this.$store.getters.token,
            //     comment: this.comment
            // }
            // if (this.imglist.length > 0) {
            //     params.attr = this.imglist
            // }
            // console.log(params)
            // this.$api.map.createComment(params).then(res => {
            //     if (res.code == 200) {
            //         this.$toast('提交成功')
            //         this.$router.back(-1);
            //     }
            // })
        },
        // 图片上传
        onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        },
        // 字数统计
        inputFun(value) {
            console.log(value)
            if (this.num <= 500) {
                this.num = value.length
            } else {
                this.num = 500
            }

        },
        // 选择问题类型
        selectType(type) {
            this.type = type
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
